import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview", "content"]
  static values = {
    types: Array
  }

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const selectedId = this.selectTarget.value
    const type = this.typesValue.find((t) => String(t.id) === String(selectedId))

    if (type) {
      this.contentTarget.innerHTML = `
        <p><span class="font-medium text-slate-600">Type:</span> ${type.label}</p>
        <p><span class="font-medium text-slate-600">Age Range:</span> ${type.min_age_years} - ${type.max_age_years} years</p>
        <p><span class="font-medium text-slate-600">Gender:</span> ${type.gender}</p>
        <p><span class="font-medium text-slate-600">Fee:</span> ${type.formatted_price}</p>
      `
      this.previewTarget.classList.remove("hidden")
    } else if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
      this.contentTarget.innerHTML = ""
    }
  }
}
